import { InteriorLink } from "./interior-components.js";
import "./audience-content.css";

const articles = {
  employers: [
    {
      href: "/intelligence/job-descriptions-ot-security-risk",
      title: "Your job description could be an attacker’s next lead.",
      copy: "Explain the role without exposing sensitive details. Learn how public technology names can become clues about your environment.",
      action: "Read the Job Description Article",
    },
    {
      href: "/intelligence/useful-ot-cybersecurity-hiring-assessment",
      title: "What a Useful OT Cybersecurity Hiring Assessment Looks Like",
      copy: "See how an assessment explores relevant work and connects the findings to a hiring or development decision.",
      action: "Read the Assessment Article",
    },
  ],
  professionals: [
    {
      href: "/intelligence/questions-before-accepting-ot-security-job",
      title: "Before You Accept an OT Security Job: 12 Questions to Ask",
      copy: "Ask about authority, plant access, resources, travel, and the support available.",
      action: "Read the 12 Questions",
    },
    {
      href: "/intelligence/ot-cybersecurity-resume",
      title: "How to describe OT Cybersecurity experience on your resume",
      copy: "Explain the responsibilities you held, the decisions you made, and the operating conditions behind your work.",
      action: "Read the Resume Article",
    },
  ],
};

export function AudienceArticles({ audience }: { audience: keyof typeof articles }) {
  return (
    <section className="audience-section audience-reading" aria-labelledby="reading-title">
      <h2 id="reading-title">Before Your Next Conversation</h2>
      <div className="audience-article-grid">
        {articles[audience].map((article) => (
          <article key={article.href}>
            <h3>{article.title}</h3>
            <p>{article.copy}</p>
            <InteriorLink href={article.href}>{article.action}</InteriorLink>
          </article>
        ))}
      </div>
    </section>
  );
}
